module.exports = __webpack_public_path__ + "static/media/variable_box.9825d751.svg";